module.exports = __webpack_public_path__ + "img/Warehouse02.5982ddc7.jpg";